import Area from '@/components/Area';
import { Environment, OrbitControls, useGLTF } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import gltfModel from './day58_aluminium_bracket-transformed.glb';
import * as THREE from 'three';

function Model() {
  const { nodes } = useGLTF(gltfModel);
  const Cube = nodes.defaultMaterial as THREE.Mesh;
  // const geometry = nodes.Cube.geometry;
  // const material = nodes.Cube.material;
  // console.log('Model', { nodes });
  return <mesh geometry={Cube.geometry} material={Cube.material}></mesh>;
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas>
          <ambientLight intensity={0.5} />
          <pointLight position={[10, 10, 10]} />
          <Environment preset="sunset" />
          <Model />
          <OrbitControls />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
